module.exports = __webpack_public_path__ + "static/media/anim.476ce9ea.gif";